module.exports = __webpack_public_path__ + "img/Cookie_1_resize_30.b343a2dd.png";